import { type SendAnalyticsEvent } from '@atlassian/conversation-assistant-instrumentation/types/analytics';

import { type AgentMentionConversationContext } from '../types';

import { buildTurnContext } from './build-turn-context';

type AgentMentionSubmittedAnalyticsPayload = Pick<
	AgentMentionConversationContext,
	'conversationAgentId' | 'chatSessionId' | 'chatTurnNumber'
> & {
	agentId: string;
	selectedAgentCount: number;
	sendAnalyticsEvent: SendAnalyticsEvent;
};

export const sendAgentMentionSubmittedAnalyticsEvent = ({
	agentId,
	selectedAgentCount,
	conversationAgentId,
	chatSessionId,
	chatTurnNumber,
	sendAnalyticsEvent,
}: AgentMentionSubmittedAnalyticsPayload): void => {
	const turnContext = buildTurnContext(chatSessionId, chatTurnNumber);

	sendAnalyticsEvent({
		action: 'submitted',
		actionSubject: 'mentionAgent',
		eventType: 'track',
		attributes: {
			agentId,
			source: 'chatInputSubmit',
			selectedAgentCount,
			...turnContext,
			...(conversationAgentId ? { conversationAgentId } : {}),
		},
	});
};
